import React from "react";
import "./BirthCertHeadContent.css";
const BirthCertHeadContent = () => {
  return (
    <div className="birthCertHeadContentContainer">
      <h2>
        Birth Certificate <span>Attestation</span> in Bangalore
      </h2>
      <p>
        The type of certificate attestation in which the birth certificate of a
        person is verified for international purposes is known as birth
        certificate attestation. Birth certificate attestation is included in
        non-educational certificate attestation. The main aim of birth
        certificate attestation is to guarantee the genuineness of the
        certificate. A birth certificate is the foremost document of every
        individual. It is an important record that holds the details regarding
        the birth of a child. Birth certificate attestation is a vital strategy
        for a person since it is the record showing important details like age,
        birthplace, etc. A birth certificate contains very fundamental details
        of a person such as name, birthplace, sex, date of birth, parentage,
        etc.
      </p>
    </div>
  );
};

export default BirthCertHeadContent;
